<app-stages [stages]="stages" currentStage="Lokalizacja"></app-stages>
<br>
<ng-container *ngIf='!pending() && !loading()'>
  <form autocomplete="off" novalidate [formGroup]="form" (ngSubmit)='submitAndGoNext()'>
    <fieldset>
      <app-exposed-map-control
        #exposedMapControl
        [control]="form.geometry">
      </app-exposed-map-control>
      <app-road-controls-set [expMapDict]="exposedMapControl.dictEvent()" [form]="form"></app-road-controls-set>
    </fieldset>
    <fieldset>
      <legend>
        {{ application() | locationDataParcelsSectionTitle }}
      </legend>
      <app-parcels-crud
        expMapDictPlotType="Drogowa"
        [expMapDict]="exposedMapControl.dictEvent()"
        tag="parcels"
        formControlName="parcels">
      </app-parcels-crud>
    </fieldset>
    <fieldset>
      <legend>
        {{ application() | locationDataParcels2SectionTitle }}
      </legend>
      <app-parcels-crud
        expMapDictPlotType="Powiązana"
        [expMapDict]="exposedMapControl.dictEvent()"
        tag="parcels2"
        formControlName="parcels2">
      </app-parcels-crud>
    </fieldset>
    <br>
    @if (form.propertyInfoForm; as propertyInfoForm) {
      <app-property-info-form [form]="propertyInfoForm">
      </app-property-info-form>
    }
    <div class='application-actions'>
      <button
        type='button'
        class='btn btn-secondary'
        (click)='onCancel()'>
        <span>Wstecz</span>
      </button>
      <button
        type='button'
        class='btn btn-primary'
        (click)='submitAndGoNext()'>
        <span>Zapisz i przejdź dalej</span>
      </button>
    </div>
  </form>
</ng-container>
<app-spinner *ngIf='pending()'>
  Poczekaj trwa zapisywania danych...
</app-spinner>
<app-spinner *ngIf='loading()'>
  Poczekaj trwa ładowanie danych...
</app-spinner>
